module.exports = __webpack_public_path__ + "img/arrows-from-line.0c23b710.svg";